module.exports = __webpack_public_path__ + "img/Licor43.bafc2a71.jpg";